module.exports = __webpack_public_path__ + "img/doctor.8a1d238e.png";